import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { OfferCountdown } from './OfferCountdown';
import { checkoutUrl, originalPrice, price } from '../data/kit';
export function MobileStickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const offer = document.getElementById('oferta');
      const pastHero = window.scrollY > 700;
      let inOffer = false;
      if (offer) {
        const rect = offer.getBoundingClientRect();
        inOffer = rect.top < window.innerHeight && rect.bottom > 0;
      }
      setVisible(pastHero && !inOffer);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-204" data-mp="109v16c783sdc">
      {visible && <motion.div initial={{
      y: '100%',
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: '100%',
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-surface px-4 py-3 md:hidden" data-id="element-205" data-mp="157mv1brfhok6">
          <div className="flex items-center justify-between gap-3" data-id="element-206" data-mp="21b40631muxed">
            <div data-id="element-207" data-mp="1wcsqbsbc8mw5">
              <p className="flex items-baseline gap-2" data-id="element-208" data-mp="1wdc4qz1s4t5f">
                <span className="font-display text-xl font-black leading-none text-brand" data-id="element-209" data-mp="1wex3l0v4my93">{price} ARS</span>
                <span className="text-xs text-muted line-through" data-id="element-210" data-mp="2u2dtdzd6q4ao">{originalPrice}</span>
              </p>
              <OfferCountdown variant="inline" data-id="element-211" data-mp="2karnmijm8xfb" />
            </div>
            <a href={checkoutUrl} className="whitespace-nowrap rounded-full bg-cta px-5 py-3 font-display text-sm font-extrabold uppercase text-cta-ink transition-colors duration-150 ease-out hover:bg-cta-hover" data-id="element-212" data-mp="2k96t2sxaxehg">
              Quiero el kit
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}